import {createContext, Dispatch, SetStateAction} from 'react';

export type ContextProps = {
  isOpenDiscardModal: boolean;
  setLinkToGo: Dispatch<SetStateAction<string>>;
  setIsFormTouched: Dispatch<SetStateAction<boolean>>;
  closeDiscardModal: () => void;
  setShouldOpenDiscardModal: Dispatch<SetStateAction<boolean>>;
  discardChangesAndRestart: () => void;
  linkToGo: string;
  isFormTouched: boolean;
  checkIfOpenDiscardModalAndRedirect: (link: string) => void;
};

export const OpenModalsContext = createContext<ContextProps>({
  isOpenDiscardModal: false,
  setLinkToGo: () => {},
  setIsFormTouched: () => {},
  closeDiscardModal: () => {},
  setShouldOpenDiscardModal: () => {},
  discardChangesAndRestart: () => {},
  linkToGo: '',
  isFormTouched: false,
  checkIfOpenDiscardModalAndRedirect: () => {},
});
